import React, {Component} from 'react';
import * as firebase from 'firebase';
import MetaTags from 'react-meta-tags';
import '../css/about.css';
import Thxbg from '../images/自我肯定-350.gif';

export default class Contact extends Component {
  constructor(props) {
    super(props);
    this.state = {
      Consumption_patterns: true,
      title: '',
      name:'',
      mail:'',
      repeat: '',
      send: false,
      loading: false
    }
    this.handleChangeTitle = this.handleChangeTitle.bind(this);
    this.handleChangeName = this.handleChangeName.bind(this);
    this.handleChangeMail = this.handleChangeMail.bind(this);
    this.onChange = this.onChange.bind(this);
    this.handleSave = this.handleSave.bind(this);
  }
  handleChangeTitle(event) {
    this.setState({title: event.target.value})
  }
  handleChangeName(event) {
    this.setState({name: event.target.value})
  }
  handleChangeMail(event) {
    this.setState({mail: event.target.value})
  }
  onChange(e) {
    this.setState({value: e.target.value})
  }
  handleSave(e) {
    e.preventDefault()
    const mailBoxRef = firebase.database().ref('mailBox/').push()
    const mailBoxId = mailBoxRef.key
    mailBoxRef.update({
      title: this.state.title,
      name: this.state.name,
      mail: this.state.mail,
      value: this.state.value,
      id: mailBoxId,
      createDate: new Date().toLocaleDateString(),
      createTime: new Date().toLocaleTimeString(),
      repeat: '未回覆'
    })
    this.setState({ send: true})
    setTimeout(() => this.setState({ loading: true }), 400);
    // window.location = ('/');
  }
  componentDidMount () {
    window.scrollTo(0, 0);
  }
  render() {
    const { loading } = this.state;
    if(loading) {
      return <div style={{display: this.state.send ? 'flex' : 'none', background: '#eeede9', padding: 30, height: '100vh',justifyContent: 'center', alignItems:'center'}} >
        <div>
          <img src={Thxbg} alt="謝謝您" />
          <p style={{textAlign: 'center'}} >表單已送出， 我們將由專人處理 謝謝您。</p>
        </div>
      </div>
    }
    return(
      <div className="container-fluid">
       <div className="row">
       <MetaTags>
            <title>草學藥事 || 聯絡我們</title>
            <meta id="og-title" property="og:title" content="聯絡我們" />
        </MetaTags>
        <div className="AboutBanner">
         <div className="container">
          <div className="row">
           <div className="xs-12 sm-12 md-12 lg-12">
            <div style={{padding: '70px 15px 0'}}>
             <h1>聯絡我們</h1>
             <p>有任何疑問或合作方式 歡迎與我們聯繫</p>
            </div>
           </div>
          </div>
         </div>
        </div>
        <div className="container">
         <div className="row">
         <form id="gform" style={Jeyu.fluid} onSubmit={this.handleSave} >
          <div className="contactBox">
           <label style={Jeyu.block} htmlFor="Title">標題:</label>
           <input type="text" required="true" value={this.state.title} onChange={this.handleChangeTitle} id="Title" style={Jeyu.inputText} className="inputText" name="Title" placeholder="請輸入標題" />
          </div>
          <div className="contactBox">
           <label style={Jeyu.block} htmlFor="Name">姓名:</label>
           <input type="text" required="true" value={this.state.name} onChange={this.handleChangeName} id="Name" style={Jeyu.inputText} className="inputText" name="Name" placeholder="請輸入您的姓名" />
          </div>
          <div className="contactBox">
           <label style={Jeyu.block} htmlFor="Mail">信箱:</label>
           <input type="email" required="true" value={this.state.mail} onChange={this.handleChangeMail} id="Mail" style={Jeyu.inputText} className="inputText" name="Mail" placeholder="請輸入mail" />
          </div>

          <div style={Jeyu.mt20}>
           <label style={Jeyu.block}>您的寶貴意見:</label>
           <textarea value={this.state.value} onChange={this.onChange} style={Jeyu.textarea} name="Question" required="true"></textarea>
          </div>
          <input type="submit" value="Submit" style={Jeyu.btn} />
         </form>
         
         </div>
        </div>


      </div>
     </div>
    )
  }
}

const Jeyu = {
    bannerPhotoBox: {
      width: 200,
      height: 200,
      overflow: 'hidden',
      borderRadius: 150,
      boxShadow: '1px 1px 7px rgba(0,0,0,.2)'
    },
    bannerPhoto: {
      width: 200,
      height: 200,
    },
    center: {
     display: 'block',
     textAlign: 'left'
    },
    pinfo: {
      fontSize: 18,
      textAlign: 'left',
      margin: '20px 0',
      fontWeight: 100
    },
    h2: {
      fontSize: 23,
      fontWeight: 300
    },
    tag: {
      background: 'rgb(21, 222, 203)',
      color: 'rgb(1, 72, 82)',
      padding: '2px 15px',
      borderRadius: 7,
      fontSize: 16,
      marginRight: 10,
      fontWeight: 500
    },
    time: {
      marginLeft: 10
    },
    haspt: {
      paddingTop: 17
    },
    flexRow: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-start',
      alignItems: 'center'
    },
    labelFirst: {
      background: '#fff',
      border: '1px solid #dcdcdd',
      borderRadius: 7,
      color: '#333',
      fontSize: 15,
      padding: '7px 15px 10px',
      margin: '10px 10px 10px 0',
      cursor: 'pointer',
      display: 'inline-block'
    },
    label: {
      background: '#fff',
      border: '1px solid #dcdcdd',
      borderRadius: 7,
      color: '#333',
      fontSize: 15,
      padding: '7px 15px 10px',
      margin: '10px',
      cursor: 'pointer',
      display: 'inline-block'
    },
    none: {
      display: 'none'
    },
    block: {
      display: 'block'
    },
    hasMargin: {
      margin: '0 10px'
    },
    inputText: {
      height: 40,
      border: '1px solid #014852',
      margin: '10px 0',
      borderRadius: 3,
      padding: '3px 7px'
    },
    fluid: {
      width: '100%',
      padding: '70px 10px 50px'
    },
    textarea: {
      width: '100%',
      minHeight: 250,
      padding: 10
    },
    btn: {
      background: '#014852',
      color: '#fff',
      padding: '7px 17px',
      borderRadius: 3,
      border: '1px solid #014852',
      fontSize: 15,
      cursor: 'pointer',
      margin: '15px 0 0 0'
    },
    mt20: {
      marginTop: 20
    }
  }
  


// WEBPACK FOOTER //
// ./src/View/Contact.js